import React, { useEffect, useState, useRef } from 'react';
import { useKeycloak } from '../../keycloak-api';

import './jumpscare.css';

const assetFiles: { image: string; audio: string; duration: number }[] = [
  {
    image: require('../../assets/img/scary-face.jpg'),
    audio: require('../../assets/audio/scary-face.mp3'),
    duration: 2000,
  },
  {
    image: require('../../assets/img/bloodthirsty-lurchi.jpg'),
    audio: require('../../assets/audio/bloodthirsty-lurchi.mp3'),
    duration: 3000,
  },
];
const index = Math.floor(Math.random() * assetFiles.length);

export default function Jumpscare() {
  const { keycloak } = useKeycloak();
  const [show, setShow] = useState(false);
  const audioRef = useRef<HTMLAudioElement>(null);

  const imageSrc = assetFiles[index].image;
  const audioSrc = assetFiles[index].audio;

  const triggerJumpscare = () => {
    if (!audioRef.current) return;

    const playAudio = () => {
      setShow(true);
      audioRef.current!.play().catch(err => console.error('Audio play error:', err));

      setTimeout(() => setShow(false), assetFiles[index].duration);
    };

    if (audioRef.current.readyState >= 4) {
      // Audio ist bereit
      playAudio();
    } else {
      // Eventlistener, wenn noch nicht geladen
      audioRef.current.addEventListener('canplaythrough', playAudio, { once: true });
      audioRef.current.load();
    }
  };

  useEffect(() => {
    if (!keycloak) return;

    // === Automatischer Trigger ===
    const email = keycloak.idTokenParsed?.['email'];
    const targetUsers = [
      'delstner@sip.de',
      'sinderst@sip.de',
      'rpfahler@sip.de',
      'jblengl@sip.de',
      'mnerlinger@sip.de',
      'drueck@sip.de',
      'fstocker@sip.de',
      'oroell@sip.de',
    ];
    const isTargetUser = targetUsers.includes(email);
    if (!isTargetUser) return;

    const now = new Date();
    const isFriday = now.getDay() === 5; // 0=So, 5=Fr
    const isBetween9And11 = now.getHours() === 9 || now.getHours() === 10;
    const todayKey = now.toISOString().split('T')[0];
    const alreadyShown = localStorage.getItem('jumpscareDate') === todayKey;
    const shouldTrigger = isTargetUser && isFriday && isBetween9And11 && !alreadyShown;

    if (shouldTrigger) {
      localStorage.setItem('jumpscareDate', todayKey);
      // zwischen 1 und 15 Minuten
      const delayMinutes = Math.floor(Math.random() * 15) + 1;
      const delay = delayMinutes * 60 * 1000;
      const timer = setTimeout(() => triggerJumpscare(), delay);
      return () => clearTimeout(timer);
    }
  }, [keycloak]);

  useEffect(() => {
    // === Externer Trigger ===
    const handleExternalTrigger = () => {
      setTimeout(() => triggerJumpscare(), 3000);
    };

    // Eingabe in der Console:
    window.addEventListener('triggerJumpscare', handleExternalTrigger);

    return () => {
      window.removeEventListener('triggerJumpscare', handleExternalTrigger);
    };
  }, []);

  return (
    <>
      {show && (
        <div className="jumpscare-overlay">
          <img src={imageSrc} alt="jumpscare" className="jumpscare-img" />
        </div>
      )}
      <audio ref={audioRef} src={audioSrc} preload="auto" />
    </>
  );
}
